<div>
  <div class="flex items-center justify-center h-[50px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium"> Note </h4>
  </div>
  <mat-dialog-content class="!pt-0">
    <form [formGroup]="createNoteForm">
      <!-- Note -->
      <div class="mt-1 mb-5">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full cmn-md-form-field !h-[150px]">
          <mat-label>Note</mat-label>
          <textarea matInput formControlName="note" rows="6" placeholder="Enter Note"
          class="!resize-none !text-xs !pt-[5px]" style="height: 140px !important;"  maxlength="2000"></textarea>
          @if (createNoteForm.get('note')?.hasError('required')) {
            <mat-error class="w-full">
              Note is required
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Submit Button -->
      <mat-dialog-actions class="!px-0 flex !justify-center !pt-0">
        <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">Cancel</button>
        <button mat-flat-button class="text-primary primary-button" (click)="onSubmit()">Save</button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>